const Hero = ({text, backdrop, smallText, backdropOpacity = 0.5}) => {
    return (
      <header className="text-white p-5 hero-container"  style={{ backgroundColor: '#ffb226'}}>
        <h1 className="hero-text text-center">{text}</h1>
        <div className="hero-backdrop p-3 text-white" style={{backgroundImage:`url(${backdrop})`,  opacity: backdropOpacity}}>
          {smallText}
        </div>
      </header>
    )
  }

export default Hero